<table aria-label="policy-table" class="table" *ngIf="list?.length">
    <thead class="bg-light">
        <tr>
            <ng-container *ngFor="let key of keys">
                <th scope="col">{{key?.label}}</th>
            </ng-container>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let item of list">
            <tr>
                <ng-container *ngFor="let key of keys">
                    <td>
                        <h6 class="m-0">{{ getValue(item, key) }}</h6>
                    </td>
                </ng-container>
            </tr>
        </ng-container>
    </tbody>
</table>
